import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches all vendor invoices for Approval Persons (All Invoices tab - same data as admin view)
 * @returns {Promise<Array>} - API response containing list of all vendor invoices
 */
export const getAllVendorInvoicesApprovalPerson = async () => {
  try {
    const response = await apiClient.get(
      '/approvalPersonInvoiceManagement/invoice/all-vendor-invoices'
    );

    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
